import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl, FormControlLabel,
    FormLabel, Radio, RadioGroup, Snackbar, Alert
} from "@mui/material";
import {Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import TextField from '@mui/material/TextField';
import {Autocomplete, DateRangePicker} from "@mui/lab";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import {connectionErrorMessage, errorMessage, featureTypeListUrl, getTenantList} from "../data";
import {toast} from "react-toastify";
import EtcMultiSelectDataGrid from "../ui/grid/EtcMultiSelectDataGrid";
import DiscountCodeInputFormDialog from "./DiscountCodeInputFormDialog";
import {debugLog} from "../debug";


function FormDialog(props) {

    const [discountCouponDto, setDiscountCouponDto] = useState({});
    useEffect(() => {
        if (props.selectedModel && props.openType === "edit") {
            if (props.selectedModel.id || (discountCouponDto && discountCouponDto.id && discountCouponDto.id !== props.selectedModel.id)) {
                let discountCouponDto = {};
                discountCouponDto.id = props.selectedModel.id;
                discountCouponDto.name = props.selectedModel.name;
                discountCouponDto.validIntervalBeginDateTime = props.selectedModel.validIntervalBeginDateTime;
                discountCouponDto.validIntervalEndDateTime = props.selectedModel.validIntervalEndDateTime;
                discountCouponDto.tenantIdSet = props.selectedModel.tenantIdSet;
                discountCouponDto.subscriptionServiceFeatureTypeIdSet = props.selectedModel.subscriptionServiceFeatureTypeIdSet;
                discountCouponDto.discountType = props.selectedModel.discountType;
                discountCouponDto.discountAmount = props.selectedModel.discountAmount;
                discountCouponDto.discountRate = props.selectedModel.discountRate;
                discountCouponDto.fixedAmount = props.selectedModel.fixedAmount;
                discountCouponDto.declaredFileCount = props.selectedModel.declaredFileCount;
                discountCouponDto.declaredTokenCount = props.selectedModel.declaredTokenCount;
                discountCouponDto.declaredUserCount = props.selectedModel.declaredUserCount;
                discountCouponDto.subscriptionBillingTypeName = props.selectedModel.subscriptionBillingTypeName;
                discountCouponDto.subscriptionBillingTypeEnumValue = props.selectedModel.subscriptionBillingTypeEnumValue;
                discountCouponDto.subscriptionServiceTypeEnumValue = props.selectedModel.subscriptionServiceTypeEnumValue;
                setShowDiscountTypeInput(props.selectedModel.discountType);
                setSelectedTenantIdList(props.selectedModel.tenantIdSet);
                setSelectedFeatureTypeIdList(props.selectedModel.subscriptionServiceFeatureTypeIdSet);
                setSelectedSubscriptionServiceTypeValue(props.selectedModel.subscriptionServiceTypeEnumValue);
                setDiscountCouponDto(discountCouponDto)
            } else {
                setSelectedTenantIdList([]);
                setSelectedFeatureTypeIdList([]);
                setDiscountCouponDto({})
                setShowDiscountTypeInput(false);
            }
        } else {
            setSelectedTenantIdList([]);
            setSelectedFeatureTypeIdList([]);
            setDiscountCouponDto({})
            setShowDiscountTypeInput(false);
        }
        // eslint-disable-next-line
    }, [props.selectedModel]);

    const [dateRange, setDateRange] = useState([new Date(), new Date(new Date().setFullYear(new Date().getFullYear() + 1))]);
    const [showDiscountTypeInput, setShowDiscountTypeInput] = useState(false);
    const [tenantList, setTenantList] = useState([]);
    const [selectedTenantIdList, setSelectedTenantIdList] = useState([]);
    const [selectedFeatureTypeIdList, setSelectedFeatureTypeIdList] = useState([]);
    const [subscriptionFeatureTypeDtoList, setSubscriptionFeatureTypeDtoList] = useState([]);
    const [showSnackbar, setShowSnackbar] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [openDiscountCodeInputFormDialog, setOpenDiscountCodeInputFormDialog] = React.useState(false);
    const [selectedSubscriptionServiceTypeValue, setSelectedSubscriptionServiceTypeValue] = React.useState("UGY");

    useEffect(() => {
        getDataTenantList();
        getFeatureTypeList();
    }, []);


    const getFeatureTypeList = () => {
        fetch(featureTypeListUrl)
            .then(res => res.json())
            .then((data) => {
                setSubscriptionFeatureTypeDtoList(data)
            }, (error) => {
                if (error) {
                    toast.error(connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const handleCloseAlert = () => {
        setShowSnackbar(false);
    }

    const handleCloseSnackbar = () => {
        setShowSnackbar(false);
    }

    const getDataTenantList = () => {
        fetch(getTenantList)
            .then(res => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(errorMessage);
                }
            })
            .then((data) => {
                if (!data) {
                    return;
                }
                setTenantList(data);

            }, (error) => {
                debugLog(error);
                if (error) {
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            });
    }

    const onSelectionModelChange = (selection) => {
        if (selection) {
            setSelectedTenantIdList(selection);
        }
    }

    const onSelectionFeatureTypeModelChange = (selection) => {
        if (selection) {
            setSelectedFeatureTypeIdList(selection);
        }
    }

    const handleCloseDiscountCodeInputFormDialog = () => {
        setOpenDiscountCodeInputFormDialog(false);
    };


    const generateDiscountCouponCode = () => {
        setOpenDiscountCodeInputFormDialog(true);
    };


    const handleAcceptDiscountCodeInputFormDialog = (codeCount, startPrefixCode) => {

        if (codeCount < discountCouponDto.tenantIdSet.length) {
            setShowSnackbar(true);
            setAlertMessage("En az Kurum Sayısı kadar kod oluşturabilirsiniz!");
            return;
        }

        discountCouponDto.useCouponCodeCount = codeCount;
        discountCouponDto.useCouponCodePrefix = startPrefixCode;
        props.handleSave(discountCouponDto)
        setOpenDiscountCodeInputFormDialog(false);
    }
    const setTenantPropertiesInputProps = {inputMode: 'numeric', pattern: '[0-9]*', style: {height: '0.3rem'}};

    const getSubscriptionProcessLimit = () => {
        return <>
            {showDiscountTypeInput === "FIXED" && <><span>İşlem Sınırları:</span>
                <div style={{display: 'grid', paddingTop: 5}}>
                    <TextField style={{padding: 10, width: 200}} InputLabelProps={{shrink: true, height: 2}}
                               size="small" type="number"
                               label={"İşlem Yapılacak Dosya Sayısı"}
                               onChange={(item) => {
                                   discountCouponDto.declaredFileCount = item.target.value;
                                   setDiscountCouponDto(discountCouponDto);
                               }}
                               defaultValue={props.selectedModel ? props.selectedModel.declaredFileCount : discountCouponDto?.declaredFileCount}
                               inputProps={setTenantPropertiesInputProps}/>
                    <TextField style={{padding: 10, width: 200}} InputLabelProps={{shrink: true}} size="small"
                               type="number"
                               label={"TOKEN'lı Avukat Sayısı"}
                               onChange={(item) => {
                                   discountCouponDto.declaredTokenCount = item.target.value;
                                   setDiscountCouponDto(discountCouponDto);
                               }}
                               defaultValue={props.selectedModel ? props.selectedModel.declaredTokenCount : discountCouponDto?.declaredTokenCount}
                               inputProps={setTenantPropertiesInputProps}/>
                    <TextField style={{padding: 10, width: 200}} InputLabelProps={{shrink: true}} size="small"
                               type="number"
                               label={"Kullanıcı Sayısı"}
                               defaultValue={props.selectedModel ? props.selectedModel.declaredUserCount : discountCouponDto?.declaredUserCount}
                               onChange={(item) => {
                                   discountCouponDto.declaredUserCount = item.target.value;
                                   setDiscountCouponDto(discountCouponDto);
                               }}
                               inputProps={setTenantPropertiesInputProps}/>
                </div>
            </>}
        </>;
    }

    return (
        <Dialog
            fullScreen
            open={props.openDialog}
            onClose={props.handleClose}
            aria-labelledby="responsive-dialog-title">
            <DialogTitle id="responsive-dialog-title" style={{border: '1px solid #dee2e6', color: 'sandybrown'}}>
                <div>
                    <p style={{
                        verticalAlign: 'middle',
                        float: 'left',
                        fontSize: 30,
                        margin: 0,
                        paddingTop: 8,
                        color: props.color
                    }}>{"İndirim Kuponu Oluştur"}</p>
                    <SpeakerNotesIcon style={{fontSize: 60, float: 'right', color: props.color}}/>
                </div>
            </DialogTitle>
            <DialogContent style={{paddingTop: 0, paddingBottom: 0}}>
                <Box style={{alignItems: 'center', display: 'flex'}}
                     component="form"
                     sx={{
                         '& > :not(style)': {m: 1},
                     }}
                     noValidate
                     autoComplete="off"
                >
                    <Autocomplete size="small"
                                  sx={{width: 200}}
                                  defaultValue={(props.selectedModel && props.selectedModel.subscriptionServiceTypeId) ? {
                                      label: props.selectedModel.subscriptionServiceTypeName,
                                      value: props.selectedModel.subscriptionServiceTypeEnumValue
                                  } : ""}
                                  value={discountCouponDto.subscriptionServiceTypeName}
                                  onChange={(event, item) => {
                                      if (item) {
                                          if(item.value === "AHTAPOT") {
                                              setShowDiscountTypeInput("FIXED");
                                              discountCouponDto.discountType="FIXED";
                                              discountCouponDto.declaredFileCount = 500;
                                              discountCouponDto.declaredTokenCount = 3;
                                              discountCouponDto.declaredUserCount = 3;
                                          }
                                          discountCouponDto.subscriptionServiceTypeEnumValue=item.value;
                                          setDiscountCouponDto(discountCouponDto);
                                          setSelectedSubscriptionServiceTypeValue(item.value);
                                      }
                                  }}
                                  options={[{label: 'UGY', value: 'UGY'},
                                      {label: 'AHTABOT', value: 'AHTAPOT'}]}
                                  renderInput={(params) => <TextField {...params} label="Ürün Tipi"/>}
                    />

                    <TextField size="small" sx={{width: 140}} label="Kampanya Adı"
                               defaultValue={props.selectedModel ? props.selectedModel.name : ""}
                               onChange={(item) => {
                                   discountCouponDto.name = item.target.value;
                                   setDiscountCouponDto(discountCouponDto);
                               }}
                    />

                    <FormControl component="fieldset">
                        <FormLabel size="sm" style={{marginBottom: -5, textAlign: 'center'}} component="legend">İndirim
                            Tipi</FormLabel>
                        <RadioGroup row aria-label="indirimTipi" name="row-radio-buttons-group"
                                    defaultValue={props.selectedModel ? props.selectedModel.discountType : ""}
                                    onChange={(item) => {
                                        discountCouponDto.discountType = item.target.value;
                                        setDiscountCouponDto(discountCouponDto);
                                        setShowDiscountTypeInput(item.target.value);
                                    }}>
                            {selectedSubscriptionServiceTypeValue === "UGY" ?
                                <>
                                    <FormControlLabel size="sm" value="RATE" control={<Radio/>} label="Oran"/>
                                    <FormControlLabel size="sm" value="AMOUNT" control={<Radio/>} label="Tutar"/>
                                    <FormControlLabel size="sm" value="FIXED" control={<Radio/>} label="Sabit"/>
                                </>
                            : <>
                                    <FormControlLabel size="sm" value="FIXED" control={<Radio checked={true}/>} label="Sabit"/>
                                </>}

                        </RadioGroup>
                    </FormControl>
                    {(showDiscountTypeInput === "AMOUNT") ?
                        <TextField sx={{width: 120}} size="small" label="İndirim Tutarı"
                                   defaultValue={props.selectedModel ? props.selectedModel.discountAmount : ""}
                                   onChange={(item) => {
                                       discountCouponDto.discountAmount = item.target.value;
                                       setDiscountCouponDto(discountCouponDto);
                                   }}/> : (showDiscountTypeInput === "RATE") ?
                            <TextField sx={{width: 120}} size="small" label="İndirim Oranı"
                                       defaultValue={props.selectedModel ? props.selectedModel.discountRate : ""}
                                       onChange={(item) => {
                                           discountCouponDto.discountRate = item.target.value;
                                           setDiscountCouponDto(discountCouponDto);
                                       }}/> :
                            <TextField sx={{width: 120}} size="small" label="Sabit Tutar"
                                       defaultValue={props.selectedModel ? props.selectedModel.fixedAmount : ""}
                                       onChange={(item) => {
                                           discountCouponDto.fixedAmount = item.target.value;
                                           setDiscountCouponDto(discountCouponDto);
                                       }}/>}
                    {(showDiscountTypeInput === "FIXED") &&
                    <Autocomplete size="small"
                                  sx={{width: 200}}
                                  defaultValue={(props.selectedModel && props.selectedModel.subscriptionBillingTypeName) ? {
                                      label: props.selectedModel.subscriptionBillingTypeName,
                                      value: props.selectedModel.subscriptionBillingTypeEnumValue
                                  } : ""}
                                  value={discountCouponDto.subscriptionBillingTypeValue}
                                  onChange={(event, item) => {
                                      if (item) {
                                          discountCouponDto.subscriptionBillingTypeEnumValue = item.value;
                                          discountCouponDto.subscriptionBillingTypeName = item.label;
                                          setDiscountCouponDto(discountCouponDto);
                                      }
                                  }}
                                  options={selectedSubscriptionServiceTypeValue === "UGY" ? [{label: 'Yıllık Abonelik', value: 'PRESALE_YEAR'},
                                      {label: '3 Aylık Abonelik', value: 'PRESALE_QUARTER'},
                                      {label: '6 Aylık Abonelik', value: 'PRESALE_HALF'},
                                      {label: '1 Aylık Abonelik', value: 'PRESALE_MONTH'}] : [{label: 'Yıllık Abonelik', value: 'PRESALE_YEAR'},
                                      {label: '3 Aylık Abonelik', value: 'PRESALE_QUARTER'}]}
                                  renderInput={(params) => <TextField {...params} label="Üyelik Tipi"/>}
                    />}
                    <FormControl>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateRangePicker size="small"
                                             startText="Kampanya Baş.Trh."
                                             endText="Kampanya Btş.Trh."
                                             disablePast
                                             value={props.openType === "edit" ? [new Date(props.selectedModel.validIntervalBeginDateTime), new Date(props.selectedModel.validIntervalEndDateTime)] : dateRange}
                                             onChange={(newValue) => {
                                                 setDateRange(newValue);
                                             }}
                                             renderInput={(startProps, endProps) => (
                                                 <React.Fragment>
                                                     <TextField size="small" {...startProps} sx={{width: 120}}/>
                                                     <Box sx={{mx: 1}}> ve </Box>
                                                     <TextField size="small" {...endProps} sx={{width: 120}}/>
                                                 </React.Fragment>
                                             )}
                            />
                        </LocalizationProvider>
                    </FormControl>

                    <TextField size="small" label="Açıklama"
                               defaultValue={props.selectedModel ? props.selectedModel.remark : ""}
                               sx={{width: 300}}
                               onChange={(item) => {
                                   discountCouponDto.remark = item.target.value;
                                   setDiscountCouponDto(discountCouponDto);
                               }}
                    />
                    {getSubscriptionProcessLimit()}
                </Box>
                <div style={{height: "80%"}}>
                    <div style={{display: 'flex', height: "100%", width: "100%"}}>
                        <div style={{width: "100%"}}>
                            {selectedTenantIdList && `Seçilen Kurum Sayısı : ${selectedTenantIdList.length}`}
                            <EtcMultiSelectDataGrid
                                onSelectionModelChange={onSelectionModelChange}
                                selectionModel={selectedTenantIdList}
                                data={tenantList}
                                columns={[
                                    {
                                        field: 'hbTamAdi',
                                        headerName: 'Adı',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbVergiDairesi',
                                        headerName: 'Vergi Dairesi',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbVergiSicilNo',
                                        headerName: 'Vergi Sicil No',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbClientContactRefValue',
                                        headerName: 'Referans No',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbTelNo',
                                        headerName: 'Tel No',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbIlName',
                                        headerName: 'İl',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbIlceName',
                                        headerName: 'İlçe',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 200
                                    },
                                    {
                                        field: 'hbAdres',
                                        headerName: 'Adres',
                                        headerAlign: 'left',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 1000
                                    },
                                ]}
                                pageSize={20}/>
                        </div>
                        {showDiscountTypeInput === "FIXED" && selectedSubscriptionServiceTypeValue === "UGY" &&
                        <div style={{width: "100%", paddingLeft: 15}}>
                            {selectedFeatureTypeIdList && `Seçilen Özellik Sayısı : ${selectedFeatureTypeIdList.length}`}
                            <EtcMultiSelectDataGrid
                                onSelectionModelChange={onSelectionFeatureTypeModelChange}
                                selectionModel={selectedFeatureTypeIdList}
                                data={subscriptionFeatureTypeDtoList}
                                columns={[
                                    {
                                        field: 'subscriptionServiceFeatureCategoryTypeName',
                                        headerName: 'Özellik Kategorisi',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 150
                                    },
                                    {
                                        field: 'name',
                                        headerName: 'Özellik Adı',
                                        headerAlign: 'center',
                                        headerClassName: 'cell-header',
                                        cellClassName: 'cell-data',
                                        width: 800
                                    }
                                ]}
                                pageSize={20}/>
                        </div>}

                    </div>

                </div>
            </DialogContent>
            <DialogActions style={{borderTop: '1px solid #dee2e6'}}>
                <Button onClick={() => {
                    if (props.selectedModel && props.selectedModel.id) {
                        discountCouponDto.id = props.selectedModel.id;
                    } else {
                        discountCouponDto.id = null;
                    }

                    if (!(discountCouponDto.name && discountCouponDto.name.trim().length > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("Kampanya Adı boş olamaz!");
                        return;
                    }

                    if (!(dateRange[0])) {
                        setShowSnackbar(true);
                        setAlertMessage("Kampanya Başlangıç Tarihi boş olamaz!");
                        return;
                    }
                    if (!(dateRange[1])) {
                        setShowSnackbar(true);
                        setAlertMessage("Kampanya Bitiş Tarihi boş olamaz!");
                        return;
                    }

                    discountCouponDto.validIntervalBeginDateTime = props.openType === "edit" ? props.selectedModel.validIntervalBeginDateTime : dateRange[0].getTime();
                    discountCouponDto.validIntervalEndDateTime = props.openType === "edit" ? props.selectedModel.validIntervalEndDateTime : dateRange[1].getTime();
                    discountCouponDto.tenantIdSet = selectedTenantIdList;
                    discountCouponDto.subscriptionServiceFeatureTypeIdSet = selectedFeatureTypeIdList;


                    if (!(discountCouponDto?.tenantIdSet && discountCouponDto?.tenantIdSet?.length > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("Şeçilen Kurum sayısı boş olamaz!");
                        return;
                    }

                    if (!(discountCouponDto?.discountType && discountCouponDto?.discountType?.length > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("İndirim Tipi boş olamaz!");
                        return;
                    }

                    if (!(discountCouponDto?.discountType && discountCouponDto?.discountType?.length > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("İndirim Tipi boş olamaz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "AMOUNT" && !(discountCouponDto?.discountAmount)) {
                        setShowSnackbar(true);
                        setAlertMessage("İndirim Tutarı boş olamaz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "RATE" && !(discountCouponDto?.discountRate)) {
                        setShowSnackbar(true);
                        setAlertMessage("İndirim Oranı boş olamaz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "RATE" && (discountCouponDto?.discountRate < 0 || discountCouponDto?.discountRate > 100)) {
                        setShowSnackbar(true);
                        setAlertMessage("İndirim Oranı 0 ile 100 arasında olması gerekir!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "FIXED" && !(discountCouponDto?.fixedAmount)) {
                        setShowSnackbar(true);
                        setAlertMessage("Sabit Tutarı boş olamaz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "FIXED" && !(discountCouponDto?.subscriptionBillingTypeName)) {
                        setShowSnackbar(true);
                        setAlertMessage("Üyelik tipi boş olamaz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "FIXED" && selectedSubscriptionServiceTypeValue === "UGY"
                        && !(discountCouponDto?.subscriptionServiceFeatureTypeIdSet && discountCouponDto?.subscriptionServiceFeatureTypeIdSet?.length > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("Seçilen özellik sayısı boş olamaz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "FIXED" && !(discountCouponDto?.declaredFileCount && discountCouponDto?.declaredFileCount > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("Dosya Sayısı Giriniz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "FIXED" && !(discountCouponDto?.declaredTokenCount && discountCouponDto?.declaredTokenCount > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("TOKEN'lı Avukat Sayısı Giriniz!");
                        return;
                    }

                    if (discountCouponDto?.discountType === "FIXED" && !(discountCouponDto?.declaredUserCount && discountCouponDto?.declaredUserCount > 0)) {
                        setShowSnackbar(true);
                        setAlertMessage("Kullanıcı Sayısı Giriniz!");
                        return;
                    }

                    var validFormat = null;
                    var message = "Tutar/Oran alanına girilen değeri ve formatını kontrol ediniz!";

                    if (showDiscountTypeInput === "AMOUNT") {
                        validFormat = /^\d+(\.\d{1,2})?$/.test(discountCouponDto.discountAmount);
                        message = "İndirim tutarı alanına girebileceğiniz değerde en fazla 2 ondalık basamak kullanabilir ve ondalık ayraç olarak da nokta (.) kullanabileceğiniz bir sayı girebilirsiniz. Örnek: 1234.56";
                    } else if (showDiscountTypeInput === "RATE") {
                        if (discountCouponDto?.discountRate < 0 || discountCouponDto?.discountRate > 100){
                            validFormat = false;
                            message = "İndirim oranı 0 ile 100 arasında olması gerekir!";
                        } else{
                            validFormat = /^\d+(\.\d{1,2})?$/.test(discountCouponDto.discountRate);
                            message = "İndirim oranı alanına girebileceğiniz değerde en fazla 2 ondalık basamak kullanabilir ve ondalık ayraç olarak da nokta (.) kullanabileceğiniz bir sayı girebilirsiniz. Örnek: 87.56";
                        }
                    } else {
                        validFormat = /^\d+(\.\d{1,2})?$/.test(discountCouponDto.fixedAmount);
                        message = "Sabit tutar alanına girebileceğiniz değerde en fazla 2 ondalık basamak kullanabilir ve ondalık ayraç olarak da nokta (.) kullanabileceğiniz bir sayı girebilirsiniz. Örnek: 1234.56";
                    }

                    if (!validFormat) {
                        toast.error(message, {
                            position: "top-center",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                        });
                        return;
                    }

                    setDiscountCouponDto(discountCouponDto);
                    if (props.openType === "edit") {
                        props.handleSave(discountCouponDto);
                    } else {
                        generateDiscountCouponCode();
                    }
                }} variant="primary" autoFocus>
                    Tamam
                </Button>
                <Button onClick={props.handleClose} variant="danger">
                    İptal
                </Button>
            </DialogActions>
            <Snackbar open={showSnackbar} autoHideDuration={1000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseAlert} severity="error" sx={{width: '100%'}}>
                    {alertMessage}
                </Alert>
            </Snackbar>

            <DiscountCodeInputFormDialog
                openDialog={openDiscountCodeInputFormDialog}
                handleAcceptDialog={handleAcceptDiscountCodeInputFormDialog}
                handleCloseDialog={handleCloseDiscountCodeInputFormDialog}
                validCountCode={selectedTenantIdList.length}
                color={'blue'}
                title={"Kupon Kodu Oluşturma"}
                dialogContentText={"İşlemin tamamlanması için kupon sayısı ve kupon kodu anahtarı sözcüğü giriniz!"}
            />

        </Dialog>

    );
}

export default FormDialog;